import { Icon, notification } from 'antd';
import {
  DAYS_OVERLAP,
  NOT_ENOUGH_VACATION_DAYS,
  CANT_DELETE_PROCESSED_CLAIM,
  NOT_ENOUGH_OVERTIME_DAYS,
  CANT_SAVE_PAST_TIMESHEET,
  DATE_IN_CLOSED_WEEK,
} from './errorConstants';
import React from 'react';

const errorInfo = {
  [DAYS_OVERLAP]: {
    message: 'Nieprawidłowy zakres dat',
    description:
      'Daty we wniosku są już wykorzystane. Należy odrzucić obecny wniosek i stworzyć nowy wniosek z prawidłowym zakresem dat.',
    duration: 0,
  },
  [NOT_ENOUGH_VACATION_DAYS]: {
    message: 'Niewystarczająca ilość dni wolnych',
    description:
      'Ilość wnioskowanych dni jest wieksza niz dostępna ilość dni wolnych.',
    duration: 0,
  },
  [CANT_DELETE_PROCESSED_CLAIM]: {
    message: 'Nie można skasować wniosku.',
    description: 'Wniosek został przetworzony przez administratora.',
    duration: 0,
  },
  [NOT_ENOUGH_OVERTIME_DAYS]: {
    message: 'Niewystarczająca ilość nadgodzin',
    description:
      'Ilość wnioskowanych dni jest wieksza niz dostępna ilość nadgodzin.',
    duration: 0,
  },
  [CANT_SAVE_PAST_TIMESHEET]: {
    icon: <Icon type="lock" theme="twoTone" />,
    message: 'Nie można zapisać timesheet przed 1 września',
    description:
      'W celu modyfikacji timesheet skontatuj sie z administratorem w Twojej firmie',
    duration: 0,
  },
  [DATE_IN_CLOSED_WEEK]: {
    icon: <Icon type="lock" theme="twoTone" />,
    message: 'Tydzień zamknięty',
    description:
      'W celu modyfikacji timesheet skontatuj sie z administratorem w Twojej firmie',
    duration: 0,
  },
  default: {
    message: 'Error',
    description: 'error',
    duration: 0,
  },
};

const openErrorNotification = (error) => {
  const errorCode = error.response.data.error.message;
  switch (errorCode) {
    case DAYS_OVERLAP:
    case NOT_ENOUGH_VACATION_DAYS:
    case CANT_DELETE_PROCESSED_CLAIM:
    case NOT_ENOUGH_OVERTIME_DAYS:
    case CANT_SAVE_PAST_TIMESHEET:
    case DATE_IN_CLOSED_WEEK:
      notification.open(errorInfo[errorCode]);
      break;
    default:
      notification.open(errorInfo.default);
  }
};

export default openErrorNotification;
